// Updates cart count, totals, etc. on elements with class "cart-*"

import { EVENT_CART_UPDATE } from "@app/components/cart";
import Big from "big.js";

document.addEventListener("DOMContentLoaded", () => {
  const $counts = document.querySelectorAll(".cart-count");
  const $subTotals = document.querySelectorAll(".cart-sub-total");
  const $discounts = document.querySelectorAll(".cart-discount");
  const $totals = document.querySelectorAll(".cart-total");

  document.addEventListener(EVENT_CART_UPDATE, (e: any) => {
    if ($counts.length > 0 && e.detail?.cart) {
      $counts.forEach((element) => {
        const count = e.detail.cart.item_count || 0;
        element.innerHTML = count;
      });
    }

    if ($subTotals.length > 0 && e.detail?.cart) {
      $subTotals.forEach((element) => {
        const sub_total = e.detail.cart.sub_total || 0;
        const amount = Big(sub_total)
        element.innerHTML = `$${amount.div(100).toFixed(2)}`;
      });
    }

    if ($discounts.length > 0 && e.detail?.cart) {
      $discounts.forEach((element) => {
        const discount = e.detail.cart.discount || 0;
        const amount = Big(discount)
        element.innerHTML = `$${amount.div(100).toFixed(2)}`;
      });
    }

    if ($totals.length > 0 && e.detail?.cart) {
      $totals.forEach((element) => {
        const total_price = e.detail.cart.total_price || 0;
        const amount = Big(total_price)
        element.innerHTML = `$${amount.div(100).toFixed(2)}`;
      });
    }
  });
});
